export const isAndroid = () =>
  Boolean(
    window && window.navigator && window.navigator.userAgent.match(/android/i)
  )
